import * as H from 'history'

export const sendGTMEvent = (event: Record<string, any>) => {
  // @ts-ignore
  return window.dataLayer?.push(event)
}

export const sendPageView = (location: H.Location) => {
  sendGTMEvent({
    event: 'pageview',
    page: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    },
  })
}
